import styled from 'styled-components'
import { grid, GridProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'
import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: number | string) => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled(Flex)`
  width: 100%;
  justify-content: center;
  padding-block: ${themeGet('space.17')}px;
  color: ${themeGet('colors.white')};
`

export const Content = styled.div.withConfig({ shouldForwardProp })<
  GridProps & GapProps
>`
  display: grid;
  width: 100%;

  ${grid}
  ${gap}
`
